import { TILE, FUSE_TICKS } from '../core/constants';
import { Cell } from './grid';
import { makeBomb, key } from './bombs';
export class Player {
    x;
    y;
    r;
    speed;
    ownerId;
    stats;
    bombsImOn;
    lives;
    iframes;
    alive;
    spawnCol;
    spawnRow;
    /** Останній запит на рух — використовується kick-логікою для напрямку штовхання. */
    lastIntent;
    constructor(col, row, ownerId = 0) {
        this.x = col * TILE + TILE / 2;
        this.y = row * TILE + TILE / 2;
        this.r = TILE * 0.38;
        this.speed = 2.0;
        this.ownerId = ownerId;
        this.stats = {
            range: 2, maxBombs: 1,
            wallPass: false, bombPass: false, flamePass: false,
            remote: false, kick: false,
        };
        this.bombsImOn = new Set();
        this.lives = 3;
        this.iframes = 0;
        this.alive = true;
        this.spawnCol = col;
        this.spawnRow = row;
        this.lastIntent = { dx: 0, dy: 0 };
    }
    respawn() {
        this.x = this.spawnCol * TILE + TILE / 2;
        this.y = this.spawnRow * TILE + TILE / 2;
        this.bombsImOn.clear();
        this.iframes = 90;
        this.alive = true;
        this.lastIntent = { dx: 0, dy: 0 };
    }
    decayIframes() {
        if (this.iframes > 0)
            this.iframes--;
    }
    occupiedTiles(x = this.x, y = this.y) {
        const r = this.r - 1;
        const corners = [
            [x - r, y - r], [x + r, y - r],
            [x - r, y + r], [x + r, y + r],
        ];
        const set = new Set();
        const out = [];
        for (const [px, py] of corners) {
            const c = Math.floor(px / TILE);
            const rr = Math.floor(py / TILE);
            const k = `${c},${rr}`;
            if (!set.has(k)) {
                set.add(k);
                out.push([c, rr]);
            }
        }
        return out;
    }
    isPassable(grid, bombs, x, y) {
        for (const [c, rr] of this.occupiedTiles(x, y)) {
            const t = grid.get(c, rr);
            if (t === Cell.HardBlock)
                return false;
            if (t === Cell.SoftBlock && !this.stats.wallPass)
                return false;
            const hasBomb = bombs.some(b => b.col === c && b.row === rr);
            if (hasBomb && !this.bombsImOn.has(`${c},${rr}`) && !this.stats.bombPass)
                return false;
        }
        return true;
    }
    tryMove(grid, bombs, intent) {
        this.lastIntent = intent;
        let { dx, dy } = intent;
        if (dx === 0 && dy === 0)
            return;
        if (dx !== 0 && dy !== 0) {
            const k = Math.SQRT1_2;
            dx *= k;
            dy *= k;
        }
        const sx = dx * this.speed;
        const sy = dy * this.speed;
        const nx = this.x + sx;
        const ny = this.y + sy;
        if (this.isPassable(grid, bombs, nx, ny)) {
            this.x = nx;
            this.y = ny;
        }
        else if (this.isPassable(grid, bombs, nx, this.y)) {
            this.x = nx;
        }
        else if (this.isPassable(grid, bombs, this.x, ny)) {
            this.y = ny;
        }
        else {
            const SNAP = 6;
            if (sx !== 0 && sy === 0) {
                const subY = ((this.y % TILE) + TILE) % TILE;
                const dist = subY - TILE / 2;
                if (Math.abs(dist) <= SNAP) {
                    const tryY = this.y - Math.sign(dist);
                    if (this.isPassable(grid, bombs, nx, tryY)) {
                        this.x = nx;
                        this.y = tryY;
                    }
                }
            }
            else if (sy !== 0 && sx === 0) {
                const subX = ((this.x % TILE) + TILE) % TILE;
                const dist = subX - TILE / 2;
                if (Math.abs(dist) <= SNAP) {
                    const tryX = this.x - Math.sign(dist);
                    if (this.isPassable(grid, bombs, tryX, ny)) {
                        this.x = tryX;
                        this.y = ny;
                    }
                }
            }
        }
        if (this.bombsImOn.size > 0) {
            const stillOn = new Set(this.occupiedTiles().map(([c, r]) => `${c},${r}`));
            for (const k of [...this.bombsImOn]) {
                if (!stillOn.has(k))
                    this.bombsImOn.delete(k);
            }
        }
    }
    centerTile() {
        return [Math.floor(this.x / TILE), Math.floor(this.y / TILE)];
    }
    countLiveBombs(bombs) {
        return bombs.reduce((n, b) => n + (b.ownerId === this.ownerId ? 1 : 0), 0);
    }
    placeBomb(grid, bombs) {
        if (this.countLiveBombs(bombs) >= this.stats.maxBombs)
            return null;
        const [c, r] = this.centerTile();
        if (grid.get(c, r) !== Cell.Floor)
            return null;
        if (bombs.some(b => b.col === c && b.row === r))
            return null;
        const bomb = makeBomb({
            col: c, row: r,
            range: this.stats.range,
            fuse: this.stats.remote ? 100000 : FUSE_TICKS, // remote: «вічна» бомба
            ownerId: this.ownerId,
            remote: this.stats.remote,
        });
        bombs.push(bomb);
        this.bombsImOn.add(key(c, r));
        return bomb;
    }
    applyPickup(p) {
        switch (p.kind) {
            case 'fire':
                this.stats.range += 1;
                break;
            case 'bomb':
                this.stats.maxBombs += 1;
                break;
            case 'speed':
                this.speed = Math.min(3.5, this.speed + 0.4);
                break;
            case 'wall_pass':
                this.stats.wallPass = true;
                break;
            case 'bomb_pass':
                this.stats.bombPass = true;
                break;
            case 'flame_pass':
                this.stats.flamePass = true;
                break;
            case 'remote':
                this.stats.remote = true;
                break;
            case 'kick':
                this.stats.kick = true;
                break;
        }
    }
}
